export const useExpressPaymentFeatures = () => {
  const $feature = useFeatureFlags()
  const user = useUserStore()

  const isCreditedConsumer = computed(() => !!user.creditedConsumerProfileType || user.isAthleteProfile)

  const allowApplePayOrderOnCart
      = computed(() => $feature.allowApplePayOrderOnCart && !isCreditedConsumer.value)
  const allowApplePayOrderOnCartWithBopis
      = computed(() => $feature.allowApplePayOrderOnCartWithBopis && !isCreditedConsumer.value)
  const allowApplePayOrderOnPDP
      = computed(() => $feature.allowApplePayOrderOnPDP && !isCreditedConsumer.value)
  const allowApplePayOrderOnPDPWithBopis
      = computed(() => $feature.allowApplePayOrderOnPDPWithBopis && !isCreditedConsumer.value)
  const allowExpressCheckoutWithDefaults
      = computed(() => $feature.allowExpressCheckoutWithDefaults && !isCreditedConsumer.value)
  const allowPayPalOrderOnCart
      = computed(() => $feature.allowPayPalOrderOnCart && !isCreditedConsumer.value)
  const allowPayPalOrderOnCartWithBopis
      = computed(() => $feature.allowPayPalOrderOnCartWithBopis && !isCreditedConsumer.value)
  const showExpressCheckoutButtonExpander
      = computed(() => $feature.showExpressCheckoutButtonExpander && !isCreditedConsumer.value)
  const showExpressPaymentCtasInMinicart
      = computed(() => $feature.showExpressPaymentCtasInMinicart && !isCreditedConsumer.value)
  const showExpressPaymentCtasInQuickshop
      = computed(() => $feature.showExpressPaymentCtasInQuickshop && !isCreditedConsumer.value)

  return {
    allowApplePayOrderOnCart,
    allowApplePayOrderOnCartWithBopis,
    allowApplePayOrderOnPDP,
    allowApplePayOrderOnPDPWithBopis,
    allowExpressCheckoutWithDefaults,
    allowPayPalOrderOnCart,
    allowPayPalOrderOnCartWithBopis,
    showExpressCheckoutButtonExpander,
    showExpressPaymentCtasInMinicart,
    showExpressPaymentCtasInQuickshop
  }
}
